import { Icon } from "design-react-kit";
import React from "react";
import { sortData } from "../../services/helpers";

const TableHeader = ({ columns, sortFunction, setResults, items, page }) => {
  return (
    <thead>
      <tr>
        {columns.map((column) => {
          return (
            <th key={column.name} scope="col" className="text-center">
              <div className="d-flex justify-content-center align-items-center">
                {column.name}
                {column.sortable ? (
                  <span className="d-inline-flex flex-column">
                    <span className="arrow-up">
                      <Icon
                        icon={"it-arrow-up-triangle"}
                        role="button"
                        className="sort"
                        style={{
                          width: "25px",
                          height: "25px",
                        }}
                        fill="#dadce0"
                        onClick={(e) =>
                          items !== undefined
                            ? setResults(
                                sortData(
                                  e,
                                  column.type,
                                  column.value,
                                  "desc",
                                  items,
                                  page
                                )
                              )
                            : sortFunction(e, column.value, true)
                        }
                      />
                    </span>
                    <span className="arrow-down">
                      <Icon
                        icon={"it-arrow-down-triangle"}
                        role="button"
                        className="sort"
                        fill="#dadce0"
                        style={{ width: "25px", height: "25px" }}
                        onClick={(e) =>
                          items !== undefined
                            ? setResults(
                                sortData(
                                  e,
                                  column.type,
                                  column.value,
                                  "asc",
                                  items,
                                  page
                                )
                              )
                            : sortFunction(e, column.value, false)
                        }
                      />
                    </span>
                  </span>
                ) : (
                  ""
                )}
              </div>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export default TableHeader;
